import { NgModule } from '@angular/core';
import { SharedModule } from 'app/components/shared.module';
import { SectionModule } from 'app/views/presentations/layouts/layouts/section.module';
import { TwoSectionsVerticalLayoutMirror, TwoSectionsVerticalLayoutMirrorComponent } from 'app/views/presentations/layouts/layouts/twoSectionsVerticalLayoutMirror/twoSectionsVerticalLayoutMirror.component';
import { LayoutWrapperModule } from 'app/views/presentations/layouts/layoutWrapper.module';

@NgModule({
    imports: [
        SharedModule,
        SectionModule,
        LayoutWrapperModule.wrapLayout(TwoSectionsVerticalLayoutMirror)
    ],
    declarations: [
        TwoSectionsVerticalLayoutMirrorComponent
    ],
    entryComponents: [
        TwoSectionsVerticalLayoutMirrorComponent
    ]
})
export class TwoSectionsVerticalLayoutMirrorModule { }


// WEBPACK FOOTER //
// ./src/app/views/presentations/layouts/layouts/twoSectionsVerticalLayoutMirror/twoSectionsVerticalLayoutMirror.module.ts